module.exports = __webpack_public_path__ + "media/images/logo_en-7a900e4732f83797c974c281f7934174.svg";